import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

interface EmailInputProps {
  email: string;
  onChange: (email: string) => void;
  disabled?: boolean;
}

export function EmailInput({ email, onChange, disabled }: EmailInputProps) {
  return (
    <div className="grid gap-2">
      <Label htmlFor="signerEmail">Mottakers e-postadresse</Label>
      <Input
        id="signerEmail"
        type="email"
        placeholder="ola.nordmann@example.com"
        value={email}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
    </div>
  );
}